import { ApplicationEnvironments } from 'enums/common.enums';
import { convertStringToBoolean } from 'utils/stringUtils';

export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT! as ApplicationEnvironments;
export const RESEND_CODE_TIMEOUT = 60;
export const LATIN_ALPHABET_REG_EX = /^[a-zA-Z\s]+$/;
export const NOT_LATIN_ALPHABET_REG_EX = /[^a-zA-Z\s]/g;
// timeout to show fake loader for user after prove auth complete
export const PROVE_COMPLETE_AUTH_LOADER_TIMEOUT_IN_MS = 2000;
export const PDF_FILE_TYPE = 'application/pdf';
export const IS_SMALL_LOAN_PROGRAM_PRODUCT_ENABLED = convertStringToBoolean(
  process.env.REACT_APP_IS_SMALL_LOAN_PROGRAM_PRODUCT_ENABLED!,
);
export const IS_HOTJAR_ENABLED = convertStringToBoolean(process.env.REACT_APP_IS_HOTJAR_ENABLED!);
export const IS_PROVE_PREFILL_ENABLED = convertStringToBoolean(process.env.REACT_APP_IS_PROVE_PREFILL_ENABLED!);
export const GOOGLE_TAG_MANAGER_ARGS = {
  applicationPreApproved: {
    dataLayer: {
      event: 'applicationPreapproved',
    },
  },
  applicationDecline: {
    dataLayer: {
      event: 'applicationDecline',
    },
  },
  contractorApplication: {
    dataLayer: {
      event: 'contractorApplication',
    },
  },
};
export const IS_CONCEPTUAL_HQ_ENABLED = convertStringToBoolean(process.env.REACT_APP_IS_CONCEPTUAL_HQ_ENABLED!);
export const HFS_PRIVACY_POLICY_URL = 'https://www.hfsfinancial.net/privacy-policy/';
export const HFS_TERMS_OF_USE_URL = 'https://www.hfsfinancial.net/terms-of-use/';
export const CONFIG_CAT_SDK_KEY = process.env.REACT_APP_CONFIG_CAT_SDK_KEY!;
